import { ApolloClient } from '@apollo/client'
import { createHttpLink } from '@apollo/client'
import { InMemoryCache } from '@apollo/client'
import { env } from '../../config/env'

// `isomorphic-unfetch` is gone with the server: every browser this app supports
// has fetch, and the polyfill only existed for Node during SSR.
export const client = new ApolloClient({
  link: createHttpLink({ uri: env.ptdApiBase }),
  cache: new InMemoryCache(),
  // Was true for server rendering. Leaving it on in a browser-only app suppresses
  // the very refetching the app depends on.
  ssrMode: false
})
